import { Action } from '../../../common/actions/core/action';

export class GoToOffersAction implements Action {
  constructor(public msisdn: string, public reason: string) { }
}


// WEBPACK FOOTER //
// src/app/no-auth/components/go-to-offers-dialog/go-to-offers-dialog.action.ts